import React from "react";

const detail = (props) => {
  return (
    <React.Fragment>
      <h1
        className="py-4"
        style={{
          fontFamily: "CircularStdMedium , Arial, sans-serif",
          fontSize: "35px",
          fontWeight: "normal",
          fontStretch: "normal",
          fontStyle: "normal",
          textAlign: "left",
          color: "#0f0f0f",
        }}
      >
        Lesson details
      </h1>
      {/* <!--about the project --> */}
      {/* <div className="Lesson-Col">
        <div className="right-side-panel"> */}
      <div className="user-sub-detail-card flex-between-center">
        <div>
          <div className="status">CANCELLED</div>
          <div className="name">Mawuli</div>
          <div className="normal-para">Maths (GCSE) . £20 per lesson</div>
        </div>
        <div className="Ellipse-134 flex-center-center">{"M"}</div>
      </div>
      <div className="flex info-div-P">
        <div className="info-div flex-col-center">
          <div>Start date</div>
          <div>Mon 14 May (Weekly)</div>
        </div>
        <div className="info-div flex-col-center">
          <div>Time</div>
          <div>9:00AM - 10:00AM</div>
        </div>
        <div className="info-div flex-col-center">
          <div>Location</div>
          <div>Online classroom</div>
        </div>
        <div className="info-div flex-col-center">
          <div>Price</div>
          <div>£20 per lesson</div>
        </div>
        {/* </div>
        </div> */}
      </div>
      <hr />

      {/* <section className="about-section border">
           <div className="row mx-1 my-3 justify-content-end">
                <div className="col-sm-10">
                    <h5 className="active-header">Lesson Request</h5>
                    <h5 className="data-sub-header">Mawuli</h5>
                    <p>Expires in 08:30:16</p>
                    <p>Maths (GCSE) . £20 per lesson</p>
                </div>
                    <div className="col-sm-2 align-self-center justify-content-center"><div className="sign-box"><b>M</b></div></div>
           </div>
        </section>
       
        <section className="project-start">
            <div>
                <div className="row justify-content-start details">
                  
                    <div className="col-md-3 my-3 my-md-0">
                       <h4>Start date</h4>
                        <span>Mon 14 May(Weekly)</span>
                    </div>
                  
                    <div className="col-md-3 my-3 my-md-0">
                         <h4>Time</h4>
                        <span>(9:00A.M to 10:00A.M)</span>
                    </div>
                  
                    <div className="col-md-3 my-3 my-md-0">
                         <h4>Location</h4>
                        <span>Online classroom</span>
                    </div>
                 
                    <div className="col-md-3 my-3 my-md-0">
                         <h4>Price</h4>
                        <span>£20 per lesson</span>
                    </div>
                </div>
            </div>
        </section>
        <hr></hr> */}
    </React.Fragment>
  );
};
export default detail;
